/**
 * ITEMS LIST
 * Modal containing list of items currently on the table. With links and thumbnails.
 */
import { getTableItemsData } from './table-save';

/**
 * Open custom modal
 * @param {string} messageText 
 */
export const createItemListModal = async () => {
    // Don't create if modal already open
    if (document.querySelector('.confirm-dialog__bg') !== null){
        return;
    }

    // Create dynamic HTML content
    const footer = document.querySelector('#footer');
    const confBg = document.createElement('div');
    const confDialog = document.createElement('div');

    confBg.className = 'confirm-dialog__bg modal-dialog__bg';
    confDialog.className = 'confirm-dialog modal-dialog';
    confBg.appendChild(confDialog);

    let html = '<div class="modal-dialog-inner">';
    html += '<div class="modal-header"><h3>Items List</h3><button class="button has-background has-theme-primary-background-color" id="itemslist-add-items">Add Items to Quote</button></div>';
    html += '<div class="dc-items-list-grid">';
    html += '<div class="loading-grid"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"></svg></div>';
    html += '<p class="loading-text">Loading your item details&hellip;</p>';
    html += '<p class="null-state">You have not added any items to your tabletop yet.</p>';
    html += '</div>';
    html += '<a class="close" id="itemslist-close"><svg focusable="false" class=" v-image v-close" aria-hidden="true" width="24px" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 2.927L17.072 2 10 9.073 2.928 2 2 2.927 9.072 10 2 17.073l.928.927L10 10.928 17.072 18l.928-.927L10.927 10z"></path></svg>';
    html += '</div>';
    confDialog.insertAdjacentHTML('beforeend', html);

    // Bind click events ---
    confDialog.addEventListener('click', (event) => {
        event.stopPropagation();

        // Add items to quote button
        if (event.target.matches('#itemslist-add-items')) {
            // Close modal
            confBg.remove();
            // Click "Add Items to Quote" on main actions bar
            var addToQuote = document.querySelector('#quote-it');
            if (addToQuote !== null){
                addToQuote.focus();
                addToQuote.click();
            }
        }

        // Close modal
        if (event.target.matches('#itemslist-close')) {
            confBg.remove();
        }
    });

    // Click background to close modal
    confBg.addEventListener('click', (event) => {
        confBg.remove();
    });

    // Add modal to DOM
    footer.after(confBg);
    document.body.classList.add('confirmation-active');

    // Make AJAX request to query product data
    const tableItems = getTableItemsData();
    queryItemsList(tableItems).then((posts) => {
        displayItemsListData(posts);
    });
};

/**
 * Query post data for all products in Item List
 * @param {array} tableItems Data from getTableItemsData. Object with keys corresponding to "data-var" values on table item inputs.  Values are the products that are selected.
 * @return {object}
 */
const queryItemsList = async (tableItems) => {
    // Make sure table is not empty
    if (typeof tableItems === 'undefined' || tableItems === null){
        return Promise.resolve(null);
    }

    // Create string with all post IDs, separated by comma
    let postIDsString = Object.values(tableItems).join(',');
    if (postIDsString === null || postIDsString.length === 0){
        return Promise.resolve(null);
    }

    // WordPress JSON API request, for all products with these IDs (uses endpoint that is a part of WP core)
    const postsResponse = await fetch(`/wp-json/wp/v2/product?include=${postIDsString}`);

    // If there was an error with the request
    if (!postsResponse.ok) {
        console.warn(`Post request was not OK. Status Code: ${postsResponse.status}`);
        return Promise.resolve(null);
    }

    const posts = await postsResponse.json();
    return posts;
};

/**
 * Display list of items, by category, in the Items List modal. Adds HTML to DOM.
 * @param {object} postData JSON post data returned by queryItemsList.
 * @return {void}
 */
const displayItemsListData = (postData) => {
    // Find modal element
    const dialogBg = document.querySelector('.confirm-dialog__bg');
    if (dialogBg === null){
        console.warn("Can't find Item List modal dialog element");
        return;
    }

    // Add class that hides loaders
    dialogBg.classList.add('is-loaded');

    // There was no post data.
    if (typeof postData === 'undefined' || postData === null || postData.length === 0){
        // Add class that displays null state text
        dialogBg.classList.add('no-data');
        return;
    }

    // Iterate through all posts, and add item info HTML inside the modal element.
    // These also need to be grouped by a category.
    const itemListContainer = document.querySelector('.dc-items-list-grid');
    const tableItems = getTableItemsData();

    const sections = [
        { title: 'Glassware', fieldNames: ['dc_wine_glass','dc_wine_glass_fat','dc_wine_glass_tall','dc_glass'] },
        { title: 'Plates', fieldNames: ['dc_charger','dc_big_plate','dc_small_plate'] },
        { title: 'Linen and Flatware', fieldNames: ['dc_table_cloth','dc_napkin', 'dc_dinner_fork'] },
        // { title: 'Linen and Flatware', fieldNames: ['dc_table_cloth','dc_napkin', 'dc_salad_fork','dc_dinner_fork','dc_knife','dc_spoon'] },
        { title: 'Additional Items', fieldNames: ['dc_extra_1','dc_extra_2','dc_extra_3'] },
    ];

    sections.forEach((section) => {
        // Find which existing table items are in this section
        let postsInSection = [];

        Object.keys(tableItems).forEach(function (itemKey) {
            if (section.fieldNames.includes(itemKey)){
                // Get all items (products) in this section
                let found = postData.find((post) => { return post.id.toString() === tableItems[itemKey].toString(); });
                if (typeof found !== 'undefined'){
                    postsInSection.push(found);
                }
            }
        });

         // Create HTML elements and add to DOM. 
        if (postsInSection.length > 0){
            // Create section div, with heading
            let sectionContainer = document.createElement('div');
            sectionContainer.className = 'dc-items-list-grid__section';
            
            let sectionHeading = document.createElement('h5');
            sectionHeading.innerHTML = section.title;
            sectionContainer.append(sectionHeading);

            // Create product grid items
            let itemsContainer = document.createElement('div');
            postsInSection.forEach((post) => {
                displaySingleItem(post, itemsContainer);
            });
            sectionContainer.append(itemsContainer);

            // Add section to modal
            itemListContainer.append(sectionContainer);
        }
    });


};

/**
 * Display markup for single product in the item list.
 * @param   {HTMlElement}  itemListContainer  Container element to append item to
 * @return  {void}
 */
const displaySingleItem = (post, itemListContainer) => {
    if (itemListContainer !== null){
        const pBtn = document.createElement('button');
        const pImg = new Image(150, 150);
        const pPara = document.createElement('p');

        pImg.setAttribute('src', post.featured_thumb_url);
        pImg.className = 'dc-items-list-grid__image';
        pBtn.setAttribute('data-product-id', post.id);
        pBtn.className = 'dc-items-list-grid__item';
        pPara.className = 'product-title u-titlecase has-small-font-size';

        pPara.textContent = post.title.rendered;
        pBtn.append(pImg, pPara);
        itemListContainer.append(pBtn);

        if (!post.dc_table_image_url) {
            pBtn.classList.add('no-image');
        }

        if (!pImg.src) {
            pImg.setAttribute('src', post.dc_table_image_url);
        }
    }
};